module.exports = __webpack_public_path__ + "static/img/fullscreen-image_time-attendance_768.fb7a8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/fullscreen-image_time-attendance_768.png
// module id = sUKq
// module chunks = 0